import axios from 'axios'
import { getHost } from './host'

export interface Customer {
  customer_id: number;
  account_id: number;
  name: string;
  address: string;
  logo_uri: string;
  created: string;
  updated: string;
}

export interface CreateCustomer {
  name?: string;
  address?: string;
}

export interface EditCustomer {
  customer_id: number;
  name?: string;
  address?: string;
  logo?: File;
}

export async function getCustomer(api_key: string, customer_id: number) {
  const url = `https://${getHost()}/api/customer/${customer_id}`

  const { data } = await axios.get<{ data: Customer }>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'} });
  return data.data
}

export async function createCustomer(api_key: string, customer: CreateCustomer) {
  var url = `https://${getHost()}/api/customer`

  const bodyFormData = new FormData();
  Object.keys(customer).forEach(key => bodyFormData.append(key, customer[key].toString()));
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<{data: { customer_id: number } }>(url, bodyFormData, { headers: headers });
  
  return data.data
}

export async function updateCustomer(api_key: string, customer: EditCustomer) {
  var url = `https://${getHost()}/api/customer/${customer.customer_id}`

  const bodyFormData = new FormData();
  console.log(customer)

  Object.keys(customer).forEach((key) => {
    if (key === 'logo') {
      if (customer.logo !== null) {
        bodyFormData.append('logo', customer.logo, customer.logo.name)
      }
    } else {
      bodyFormData.append(key, customer[key].toString())
    }
  });
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<{data: any}>(url, bodyFormData, { headers: headers });
  
  return data.data
}